import { useState } from "react";
import { song삭제api } from "../api/delete/song.change";
import { DateField, update업데이트 } from "../api/update.api";

type Status = "ready" | "pending" | "resolved" | "reject";

function ChangeSongPage() {
  const [songIdsToDelete, setSongIdsToDelete] = useState<string>("");
  const [statusMap, setStatusMap] = useState<{ [key: string]: Status }>({});
  const [message, setMessage] = useState<string>("");

  const parseSongIdList = (input: string): string[] => {
    const songIdList: string[] = [];
    const entries = input.split(",").map((entry) => entry.trim());

    entries.forEach((entry) => {
      if (entry.includes("~")) {
        const [startStr, endStr] = entry.split("~").map((s) => s.trim());
        const startNum = parseInt(startStr, 10);
        const endNum = parseInt(endStr, 10);

        if (isNaN(startNum) || isNaN(endNum)) {
          console.error(`잘못된 범위 입력: ${entry}`);
          return;
        }

        for (let i = startNum; i <= endNum; i++) {
          const songId = i.toString().padStart(5, "0"); // 5자리로 패딩
          songIdList.push(songId);
        }
      } else {
        const songId = entry.padStart(5, "0"); // 5자리로 패딩
        songIdList.push(songId);
      }
    });

    return songIdList;
  };

  const handleUpdateClick = async (dateField: DateField) => {
    try {
      await update업데이트("Song", dateField); // API 호출
      setMessage(`업데이트 완료`);
    } catch (error: any) {
      console.error("Error updating allUpdateDate:", error);
      setMessage(`오류 발생: ${error.message}`);
    } finally {
    }
  };

  const handleDeleteSong = async () => {
    const songIdList = parseSongIdList(songIdsToDelete);
    const newStatusMap = songIdList.reduce(
      (acc, id) => ({ ...acc, [id]: "pending" as Status }),
      {}
    );
    setStatusMap(newStatusMap);

    for (const songId of songIdList) {
      try {
        await song삭제api(songId);
        setStatusMap((prev) => ({ ...prev, [songId]: "resolved" }));
      } catch (error) {
        setStatusMap((prev) => ({ ...prev, [songId]: "reject" }));
        console.error(`[error] handleDeleteSong for ${songId}:`, error);
      } finally {
      }
    }
  };

  const getStatusMessage = (status: Status) => {
    switch (status) {
      case "ready":
        return "대기중";
      case "pending":
        return "삭제중";
      case "resolved":
        return "삭제 완료";
      case "reject":
        return "오류 발생";
      default:
        return "";
    }
  };

  return (
    <div style={styles.container}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 48,
        }}
      >
        <h1>Song 삭제 페이지</h1>
        <div>
          <p style={{ color: "red", fontWeight: "bold", width: 200 }}>
            주의해서 사용 (모든 유저가 데이터 다시 fetch하게 됨. 반드시 다
            수정하고 나서 한번에 누를 것.) {message}
          </p>
          <button onClick={() => handleUpdateClick("allUpdateDate")}>
            allUpdateDate
          </button>
          <button onClick={() => handleUpdateClick("updateDate")}>
            updateDate
          </button>
        </div>
      </div>
      <div style={styles.form}>
        <h2 style={styles.subHeader}>
          삭제할 Song ID들 (콤마로 구분, 범위 입력 둘다 됨)
        </h2>
        <input
          type="text"
          placeholder="삭제할 songId (00001, 00002) / 00001~00003"
          value={songIdsToDelete}
          onChange={(e) => setSongIdsToDelete(e.target.value)}
          style={styles.input}
        />
        <button onClick={handleDeleteSong} style={styles.button}>
          삭제하기
        </button>
      </div>

      <div style={styles.statusMessage}>
        <h3>상태:</h3>
        {Object.entries(statusMap).map(([songId, status]) => (
          <p key={songId}>
            {songId}: {getStatusMessage(status)}
          </p>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "'Arial', sans-serif",
  },
  header: {
    textAlign: "center",
    color: "#333",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "10px",
  },
  subHeader: {
    fontSize: "18px",
    color: "#555",
  },
  input: {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "4px",
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  buttonHover: {
    backgroundColor: "#0056b3",
  },
  statusMessage: {
    marginTop: "20px",
    textAlign: "center" as "center",
    color: "#333",
  },
};
export default ChangeSongPage;
